function initCountdown() {
 var countDownPDP = document.getElementById("CountDownPDP");
 var fullCountdownText = document.getElementById("FullCountdownText");
 var fullCountDownBlock = document.getElementById("product-block--countdown");

 // Only run if the elements exist
  if (!countDownPDP || !fullCountdownText) return;

// 1 - Check if past cutoff time (3PM to 23:59)
function pastCutoff(nowDate) {
  var day = nowDate.getDay(); // 0=Sun ... 6=Sat
  var hour = nowDate.getHours();

  // Hide countdown on Saturday & Sunday
  if (day === 0 || day === 6) return true;

  // Hide countdown between 3:00 PM – 11:59 PM
  if (hour >= 15) return true;
  

  // Otherwise, countdown shows
  return false;
}

// 2 - Calculate the next weekday at 3PM - this is what it is counting down to
function getNextWeekday3PM(nowDate) {
  var target = new Date(nowDate);
  var day = nowDate.getDay();
  var hour = nowDate.getHours();
  
  target.setHours(15, 0, 0, 0); // Thu 3:00 PM

  // If it's after 3PM move to next day
  if (hour >= 15) {
    target.setDate(target.getDate() + 1);
    day = (day + 1) % 7;
  }

  // If weekend, jump to Monday
  if (day === 6) { // Saturday
    target.setDate(target.getDate() + 2);
  }
  if (day === 0) { // Sunday
    target.setDate(target.getDate() + 1);
  }

  return target;
}

// 3 - Update the countdown or show generic message
function updateCountdown() {
  var nowDate = new Date();
  //var countDownPDP = document.getElementById("CountDownPDP");
  //var fullCountdownText = document.getElementById("FullCountdownText");

  // Show Free Delivery Message if past cutoff
  if (pastCutoff(nowDate)) {
    fullCountDownBlock.style.display = "none";
    return;
  }
  else {
    // Show countdown
    fullCountDownBlock.style.display = "block";
  }

  // Otherwise show countdown to next Thursday 3PM
  var next3pm = getNextWeekday3PM(nowDate);
  var distance = next3pm - nowDate;

  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

 
// Build countdown string dynamically and hide if value is 0
var parts = [];
if (days > 0) parts.push(days + "d"); // days only if >0
if (days > 0 || hours > 0) parts.push(String(hours + "hr").padStart(2, "0")); // hours only if >0, zero-padded
if (days > 0 || hours > 0 || minutes > 0) parts.push(String(minutes + "m").padStart(2, "0")); // minutes only if >0, zero-padded

// Seconds always shown, zero-padded
parts.push(String(seconds + "s").padStart(2, "0"));

// Join with colon
countDownPDP.textContent = parts.join(" ");
}

  updateCountdown(); // Run once immediately
  setInterval(updateCountdown, 1000); // Then every second
}

// Run only after DOM is ready
document.addEventListener("DOMContentLoaded", initCountdown);